module.exports = __webpack_public_path__ + "media/images/ready/icon-atom-07a36bec65276bd7aabfd9d1a72f5e4d.svg";